export const state = {
    isVisible: false,
};

export const mutations = {
    toggle: state => (state.isVisible = !state.isVisible),
};



// WEBPACK FOOTER //
// ./resources/js/store/layout/settingsBar.js